var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"941a5c8858ad3af67d7033b2748351e7f6798b0f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["transfez-business@transfez"]={id:"941a5c8858ad3af67d7033b2748351e7f6798b0f"};
      